import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const postCourse = courseData => {
  return dispatch => {
    dispatch({ type: "POST_COURSE_LOADING" });
    api
      .coursePost(courseData)
      .then(resp => {
        if (courseData.courseId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "AddCourseErrorAlertTitle",
          "Virhe muun koulutuksen tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_COURSE_SUCCEEDED",
  payload: { course: data },
});

const postEditSucceeded = data => ({
  type: "POST_COURSE_EDIT_SUCCEEDED",
  payload: { course: data },
});

const operationFail = () => ({
  type: "POST_COURSE_FAIL"
});